module.exports = __webpack_public_path__ + "static/5-d1690527ae5dea9a98dc16c01fc8f7aa.jpeg";